import React from 'react'
import Cuestionario from '../../components/postulantes/Cuestionario'

const Tests = () => {
  return (
    <div>
        <Cuestionario/>
    </div>
  )
}

export default Tests